import { InjectionToken } from '@angular/core';
export const DMS_INSTANCE_ID = new InjectionToken<string>('DMS_INSTANCE_ID');
